import { defineComponent as i, openBlock as l, createBlock as a, unref as t, withCtx as s, createVNode as n, renderSlot as p } from "vue";
import { NIconWrapper as d } from "naive-ui";
import "./highrise.es32.js";
import { COMPONENT_NAME as m } from "./highrise.es166.js";
import f from "./highrise.es116.js";
const u = i({
  name: m.FEATURE_ICON,
  inheritAttrs: !0
}), g = /* @__PURE__ */ i({
  ...u,
  props: {
    size: { default: "md" },
    shape: { default: "circle" },
    color: {},
    bgColor: {}
  },
  setup(c) {
    const o = c, r = {
      lg: 48,
      md: 40,
      sm: 32,
      xs: 24,
      "2xs": 16,
      "3xs": 12
    };
    return (e, _) => (l(), a(t(d), {
      "border-radius": e.shape == "circle" ? 50 : 0,
      size: r[o.size],
      color: o.bgColor
    }, {
      default: s(() => [
        n(t(f), {
          size: String(r[o.size] / 2),
          color: o.color
        }, {
          default: s(() => [
            p(e.$slots, "default")
          ]),
          _: 3
        }, 8, ["size", "color"])
      ]),
      _: 3
    }, 8, ["border-radius", "size", "color"]));
  }
});
export {
  g as default
};
//# sourceMappingURL=highrise.es337.js.map
